import Alert, { alertClasses } from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';

import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, shadows, spacing }) => ({
  boxShadow: shadows[4],
  maxHeight: [`calc(100vh - ${spacing(6)})`, `calc(100dvh - ${spacing(6)})`],

  color: palette.mode === 'light' ? palette.common.white : palette.common.black,
  [`&.${alertClasses.colorWarning}`]: { color: palette.warning.contrastText },

  [`.${alertClasses.action}`]: {
    flexShrink: 0,
    gap: spacing(0.5),
  },
  [`.${alertClasses.message}`]: {
    whiteSpace: 'pre-wrap',
  },
  '.Msg-iconButton': {
    width: 32,
    height: 32,
    padding: 0,
  },
});

export default function Message(props) {
  const { message, onClose, onExited, open } = props;

  const { action, content, duration, type = 'success' } = message;

  const actionClick = function () {
    onClose();
    action.onClick?.();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={duration || 6000}
      onClose={onClose}
      open={open}
      slotProps={{ transition: { onExited } }}
    >
      <Alert
        action={
          <>
            {action && <Button {...action} color="inherit" onClick={actionClick} size="small" variant="outlined" />}
            <IconButton className="Msg-iconButton" color="inherit" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} size="xs" />
            </IconButton>
          </>
        }
        css={rootCss}
        icon={
          <FontAwesomeIcon
            icon={
              type === 'success' ? faCheckCircle
              : type === 'error' ?
                faExclamationCircle
              : type === 'info' ?
                faInfoCircle
              : faExclamationTriangle
            }
            size="sm"
          />
        }
        severity={type}
        variant="filled"
      >
        {content}
      </Alert>
    </Snackbar>
  );
}
